import { render, staticRenderFns } from "./CardNeopag.vue?vue&type=template&id=55a396a0&"
import script from "./CardNeopag.vue?vue&type=script&lang=js&"
export * from "./CardNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports